// ScrollToTopButton.jsx
import { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import "./../styles/components/scroll.css";

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footerSection = document.querySelector(".footer-section"); // <-- change to your section class
      if (!footerSection) return;

      const sectionTop = footerSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Show button only when that section is visible
      if (sectionTop < windowHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {isVisible && (
        <button onClick={scrollToTop} className={`scroll-to-top-btn ${isVisible ? "show" : ""}`}>
           <FaArrowUp size={18} />
        </button>
        
      )}
    </>
  );
}